import React from 'react';
import ReactTooltip from 'react-tooltip';
import { SvgIcons } from 'common/consts/svgIcons';
import SvgIcon from 'components/Icon/Icon';
import styles from './Tooltip.module.scss';

interface Props {
  id: string;
  children: React.ReactNode;
}

const Tooltip = ({ id, children }: Props) => {
  return (
    <>
      <button className={styles.tooltipBtn} type="button" data-tip data-for={id} >
        <SvgIcon type={SvgIcons.TOOLTIP} width={15} height={15} />
      </button>
      <ReactTooltip
        id={id}
        type="dark"
        place="top"
        effect="solid"
        multiline={true}
        clickable={true}
        className={styles.tooltip}
      >
        {children}
      </ReactTooltip>
    </>
  );
};

export default Tooltip;
